import React from 'react';
import { Paper, Typography } from '@mui/material';
import { metricCardStyles } from './styles';

const TONE_COLORS = {
  default: 'text.primary',
  success: 'success.main',
  warning: 'warning.main',
  error: 'error.main',
  info: 'info.main',
};

export default function MetricCard({ label, value, helper, tone = 'default' }) {
  const toneColor = TONE_COLORS[tone] || TONE_COLORS.default;

  return (
    <Paper variant="outlined" sx={metricCardStyles.card}>
      <Typography variant="caption" color="text.secondary" sx={metricCardStyles.label}>
        {label}
      </Typography>
      <Typography variant="h5" sx={metricCardStyles.value(toneColor)}>
        {value}
      </Typography>
      {helper && (
        <Typography variant="caption" color="text.secondary" sx={metricCardStyles.helper}>
          {helper}
        </Typography>
      )}
    </Paper>
  );
}
